import {
    Alert,
    Box,
    Button,
    CardMedia,
    Fade,
    Grid,
    TextField,
    Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProductCard from '../components/ProductCard';
import { getShop } from '../features/slices';
import LayoutContainer from '../components/LayoutWrapper';
import { Link } from 'react-router-dom';


const Home = () => {
    const dispatch = useDispatch();
    const { banner, products, ads, template, last_ads } = useSelector(state => state.shop);
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const handleSubmit = (e) => {
        e.preventDefault();

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) return;

        // You could send email here to server...

        setSubmitted(true);
        setEmail('');
    };
    useEffect(() => {
        dispatch(getShop({ template, page: 1, limit: 10 }))
    }, [template]);
    return (
        <Box >
            {/* Banner */}
            {banner && (
                <Box
                    sx={{
                        height: 700,
                        backgroundImage: `url(${banner.image})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        borderRadius: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        px: 5,
                        color: 'white'
                    }}
                >
                    <LayoutContainer sx={{ textAlign: 'center' }}>
                        <Typography variant="h3" fontWeight={700}>{banner.title}</Typography>
                        <Typography variant="h6" sx={{ mt: 2 }}>{banner.subtitle}</Typography>
                        <Button
                            variant="outlined"
                            size="large"
                            component={Link}
                            to="/shop"
                            sx={{
                                borderRadius: 999,
                                textTransform: 'none',
                                fontWeight: 600,
                                px: 4,
                                py: 1.2,
                                mt: 4
                            }}
                        >
                            Shop Now
                        </Button>
                    </LayoutContainer>
                </Box>
            )}
            <LayoutContainer>


                {/* Ads Section */}
                <Grid container spacing={6} sx={{ mt: 4 }}>
                    {ads && ads.length > 0 && ads.map((ad, i) => {
                        const isEven = i % 2 === 0;
                        return (
                            <Grid item xs={12} key={i}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: { xs: 'column', md: isEven ? 'row' : 'row-reverse' },
                                        alignItems: 'center',
                                        gap: 4
                                    }}
                                >
                                    {/* IMAGE */}
                                    <Box
                                        component="img"
                                        src={ad.image}
                                        alt={ad.title}
                                        sx={{
                                            width: { xs: '100%', md: '40%' },
                                            borderRadius: 2,
                                            boxShadow: 3
                                        }}
                                    />

                                    {/* TEXT */}
                                    <Box sx={{ width: { xs: '100%', md: '60%' } }}>
                                        <Typography variant="h5" fontWeight="bold" gutterBottom>
                                            {ad.title}
                                        </Typography>
                                        <Typography variant="body1" color="text.secondary">
                                            {ad.description}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        );
                    })}
                </Grid>


                {/* Product Section */}
                <Typography variant="h4" sx={{ mt: 5, mb: 2 }}>New Arrivals</Typography>
                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        width: '100%',
                        p: 0,
                        m: 0,
                    }}
                >
                    {products.map((product) => (
                        <Box
                            key={product.id}
                            sx={{
                                width: {
                                    xs: '100%',  // 1 cột trên điện thoại
                                    sm: '50%',   // 2 cột trên màn hình nhỏ
                                    md: '33.33%',// 3 cột trên tablet
                                    lg: '25%',   // 4 cột trên desktop vừa
                                    xl: '20%',   // 5 cột trên desktop lớn
                                },
                                p: 1,
                                boxSizing: 'border-box',
                            }}
                        >
                            <ProductCard product={product} />
                        </Box>
                    ))}
                </Box>
                <Box
                    sx={{
                        mt: 6,
                        p: { xs: 3, md: 6 },
                        border: '1px solid #ccc',
                        borderRadius: 4,
                        overflow: 'hidden',
                        bgcolor: 'white'
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', md: 'row' },
                            alignItems: 'center',
                            gap: 4
                        }}
                    >
                        {/* Text Content */}
                        <Box sx={{ flex: 1 }}>
                            <Typography variant="h4" fontWeight="bold" gutterBottom>
                                {last_ads.title}
                            </Typography>
                            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                                {last_ads.description}
                            </Typography>
                            <Button
                                variant="outlined"
                                size="large"
                                component={Link}
                                to="/shop"
                                sx={{
                                    borderRadius: 999,
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    px: 4,
                                    py: 1.2
                                }}
                            >
                                Shop Now
                            </Button>
                        </Box>

                        {/* Image */}
                        <Box
                            component="img"
                            src={last_ads.image}
                            alt={last_ads.title}
                            sx={{
                                flex: 1,
                                width: '100%',
                                maxWidth: 500,
                                borderRadius: 2,
                                boxShadow: 3
                            }}
                        />
                    </Box>
                    <Box
                        sx={{
                            mt: 6,
                            py: { xs: 6, md: 10 },
                            px: { xs: 3, md: 6 },
                            backgroundImage: `url(${banner.image})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            borderRadius: 4,
                            color: 'white',
                            textAlign: 'center',
                            position: 'relative',
                            overflow: 'hidden'
                        }}
                    >
                        {/* Overlay */}
                        <Box
                            sx={{
                                position: 'absolute',
                                inset: 0,
                                bgcolor: 'rgba(0, 0, 0, 0.55)',
                                zIndex: 1
                            }}
                        />

                        {/* Content */}
                        <Box sx={{ position: 'relative', zIndex: 2, maxWidth: 600, mx: 'auto' }}>
                            <Typography variant="h4" fontWeight="bold" gutterBottom>
                                Stay in the Know
                            </Typography>
                            <Typography variant="body1" sx={{ mb: 3 }}>
                                Leave your email to receive the latest deals, exclusive offers, and new arrivals.
                            </Typography>

                            {/* Success message */}
                            <Fade in={submitted}>
                                <Alert
                                    severity="success"
                                    sx={{ mb: 2, borderRadius: 2, justifyContent: 'center' }}
                                    onClose={() => setSubmitted(false)}
                                >
                                    Thank you! We’ve received your email and will send offers your way soon.
                                </Alert>
                            </Fade>

                            {/* Form */}
                            <Box
                                component="form"
                                onSubmit={handleSubmit}
                                sx={{
                                    display: 'flex',
                                    flexDirection: { xs: 'column', sm: 'row' },
                                    gap: 2,
                                    mt: 2
                                }}
                            >
                                <TextField
                                    type="email"
                                    value={email}
                                    required
                                    placeholder="Enter your email"
                                    onChange={(e) => setEmail(e.target.value)}
                                    variant="outlined"
                                    fullWidth
                                    sx={{
                                        bgcolor: 'white',
                                        borderRadius: 2
                                    }}
                                />
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{
                                        px: 4,
                                        py: 1.5,
                                        borderRadius: 2,
                                        fontWeight: 600,
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    Subscribe
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </LayoutContainer>

        </Box >
    );
};

export default Home;
